// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewInputField input{
    width: 92%;
    height: 30%;
    /* flex-shrink: 0; */
    border-radius: 8px;
    /* border: 0.5px solid #2B4DC0; */
    background: #FFF;
    border-radius: 4px;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
}
.heading{
    font-size: 16px !important;
    font-weight: 600 !important;
    padding: 1%;
    text-decoration: underline;
}

.course-information {
    padding: 2% 17% 1% 9% !important;
    text-align: left !important;
    color: #031A1C !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: 150% !important;
}

.basic-details {
    display: flex;
    width: 100%;
}

.preview-outer-box{
    /* background-color: black; */
    width: 80%;
    justify-self: center;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    margin-top: 3%;
    margin-bottom: 3%;
}

.preview-title{
    font-weight:600 !important; 
    text-align: 'left' !important; 
    padding: '0px 0px 20px 30px' !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    line-height: 167% !important;
    font-style: normal;
    margin-bottom: 0px !important;
    font-size: 16px !important;
    justify-self: baseline;
    /* text-decoration: underline; */
    /* background-color: #F7F7F7; */
    /* background-color: rgb(25 118 210 / 16%); */
}

.topbar{
    /* justify-items: right; */
    display: flex;
    justify-content: space-between;
}

.preview-title span{
    /* margin-left: 1%; */
    border: 1px solid #000000;
    padding: 3px 10px;
    background-color: rgb(236 236 236);
    background-clip: padding-box;
    box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .07);
    position: absolute;
    margin-top: -3vh;
    
}

.course-name-label{
    width: 15%;
    font-size: 16px;
    font-weight: 600 !important;
}

.course-name{
    font-size: 16px !important;
}

.section-block{
    border: 1px solid #c7c3c3;
    border-radius: 8px;
    padding: 3px 10px;
}

.outer-section{
    /* padding-top: 2%; */
    padding-bottom: 2%;
}

.multifield-section{
    margin-top: 2%;
}

.previewLabel {
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 20px !important;
    text-align: left !important;
    margin-top: 0px !important;
    color: #484848 !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-style: normal;
    position: relative !important;
    left: -2% !important;
}

.preview-dropdown{
    width: 100% !important;
    height: 35% !important;
    flex-shrink: 0;
    border-radius: 8px !important;
    /* border: 0.5px solid #484848; */
    background: #FFF;
    line-height: 80% !important;

    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
}

.preview-field input{
    height: 11px;
}

.preview-label {
    width: 40%;
    padding-right: 5%;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 14px !important;
    font-style: normal;
    /* font-weight: 600 !important; */
    /* border: 0.5px solid #dcd0d0; */
}

.field-value{
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    border: 1px solid #e3e2e2;
    padding: 3px 10px;
    border-radius: 4px;
    min-height: 24px;
    width: 48.7%;
}

.edit-btn{
    border: 1px solid #000000 !important;
    background-color: rgb(236 236 236) !important;
    background-clip: padding-box;
    box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .07);
    min-width: 0px !important;
    max-height: 28px;
    margin-top: -3vh !important;
    margin-right: 10px !important;
}

/* .form-section:nth-child(odd) {
    background-color: #F7F7F7;
} */

@media only screen 
and (max-device-width: 1000px)
{ 
    .previewContainer {
        /* height: 60px; */
        padding: 0% 5%;
        transform: scale(98%);
    }

    .preview-outer-box{
        width: 120%;
        justify-self: center;
        border-radius: 16px;
        margin-top: 3%;
        margin-bottom: 3%;
    }

    .course-name-label{
        width: 36%;
    }

    .previewInputField{
        width: 100% !important;
        border: 0.5px solid #dcd0d0;  
        border-radius: 4px;
        display: flex;
    }

    .preview-title span {
        max-width: 62%;
    }
    
    .outer-section{
        margin-top: 10%;
    }

    .multifield-section{
        margin-top: 5%;
    }

}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/preview.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,yDAAyD;IACzD,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;AAC/B;AACA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,yBAAyB;IACzB,yDAAyD;IACzD,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,uCAAuC;IACvC,yDAAyD;IACzD,4BAA4B;IAC5B,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,gCAAgC;IAChC,+BAA+B;IAC/B,6CAA6C;AACjD;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB,kCAAkC;IAClC,4BAA4B;IAC5B,gFAAgF;IAChF,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,yDAAyD;IACzD,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,iCAAiC;IACjC,gBAAgB;IAChB,2BAA2B;;IAE3B,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,6CAA6C;IAC7C,4BAA4B;IAC5B,gFAAgF;IAChF,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;GAEG;;AAEH;;;IAGI;QACI,kBAAkB;QAClB,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;AAEJ","sourcesContent":[".previewInputField input{\n    width: 92%;\n    height: 30%;\n    /* flex-shrink: 0; */\n    border-radius: 8px;\n    /* border: 0.5px solid #2B4DC0; */\n    background: #FFF;\n    border-radius: 4px;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n.heading{\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    padding: 1%;\n    text-decoration: underline;\n}\n\n.course-information {\n    padding: 2% 17% 1% 9% !important;\n    text-align: left !important;\n    color: #031A1C !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n    line-height: 150% !important;\n}\n\n.basic-details {\n    display: flex;\n    width: 100%;\n}\n\n.preview-outer-box{\n    /* background-color: black; */\n    width: 80%;\n    justify-self: center;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 16px;\n    margin-top: 3%;\n    margin-bottom: 3%;\n}\n\n.preview-title{\n    font-weight:600 !important; \n    text-align: 'left' !important; \n    padding: '0px 0px 20px 30px' !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    line-height: 167% !important;\n    font-style: normal;\n    margin-bottom: 0px !important;\n    font-size: 16px !important;\n    justify-self: baseline;\n    /* text-decoration: underline; */\n    /* background-color: #F7F7F7; */\n    /* background-color: rgb(25 118 210 / 16%); */\n}\n\n.topbar{\n    /* justify-items: right; */\n    display: flex;\n    justify-content: space-between;\n}\n\n.preview-title span{\n    /* margin-left: 1%; */\n    border: 1px solid #000000;\n    padding: 3px 10px;\n    background-color: rgb(236 236 236);\n    background-clip: padding-box;\n    box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .07);\n    position: absolute;\n    margin-top: -3vh;\n    \n}\n\n.course-name-label{\n    width: 15%;\n    font-size: 16px;\n    font-weight: 600 !important;\n}\n\n.course-name{\n    font-size: 16px !important;\n}\n\n.section-block{\n    border: 1px solid #c7c3c3;\n    border-radius: 8px;\n    padding: 3px 10px;\n}\n\n.outer-section{\n    /* padding-top: 2%; */\n    padding-bottom: 2%;\n}\n\n.multifield-section{\n    margin-top: 2%;\n}\n\n.previewLabel {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 20px !important;\n    text-align: left !important;\n    margin-top: 0px !important;\n    color: #484848 !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-style: normal;\n    position: relative !important;\n    left: -2% !important;\n}\n\n.preview-dropdown{\n    width: 100% !important;\n    height: 35% !important;\n    flex-shrink: 0;\n    border-radius: 8px !important;\n    /* border: 0.5px solid #484848; */\n    background: #FFF;\n    line-height: 80% !important;\n\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n}\n\n.preview-field input{\n    height: 11px;\n}\n\n.preview-label {\n    width: 40%;\n    padding-right: 5%;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 14px !important;\n    font-style: normal;\n    /* font-weight: 600 !important; */\n    /* border: 0.5px solid #dcd0d0; */\n}\n\n.field-value{\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 14px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n    border: 1px solid #e3e2e2;\n    padding: 3px 10px;\n    border-radius: 4px;\n    min-height: 24px;\n    width: 48.7%;\n}\n\n.edit-btn{\n    border: 1px solid #000000 !important;\n    background-color: rgb(236 236 236) !important;\n    background-clip: padding-box;\n    box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .07);\n    min-width: 0px !important;\n    max-height: 28px;\n    margin-top: -3vh !important;\n    margin-right: 10px !important;\n}\n\n/* .form-section:nth-child(odd) {\n    background-color: #F7F7F7;\n} */\n\n@media only screen \nand (max-device-width: 1000px)\n{ \n    .previewContainer {\n        /* height: 60px; */\n        padding: 0% 5%;\n        transform: scale(98%);\n    }\n\n    .preview-outer-box{\n        width: 120%;\n        justify-self: center;\n        border-radius: 16px;\n        margin-top: 3%;\n        margin-bottom: 3%;\n    }\n\n    .course-name-label{\n        width: 36%;\n    }\n\n    .previewInputField{\n        width: 100% !important;\n        border: 0.5px solid #dcd0d0;  \n        border-radius: 4px;\n        display: flex;\n    }\n\n    .preview-title span {\n        max-width: 62%;\n    }\n    \n    .outer-section{\n        margin-top: 10%;\n    }\n\n    .multifield-section{\n        margin-top: 5%;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
